import React from 'react';

export const RedirectContext = React.createContext({
  redirects: [],
});

export const RedirectProvider = RedirectContext.Provider;
